"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Foco = /** @class */ (function (_super) {
    __extends(Foco, _super);
    function Foco() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickCaptured = false;
        _this.focusCaptured = false;
        _this.documentClick = function (event) {
            if (!_this.clickCaptured && _this.props.onClickOutside) {
                _this.props.onClickOutside(event);
            }
            _this.clickCaptured = false;
        };
        _this.innerClick = function () {
            _this.clickCaptured = true;
        };
        _this.documentFocus = function (event) {
            if (!_this.focusCaptured && _this.props.onFocusOutside) {
                _this.props.onFocusOutside(event);
            }
            _this.focusCaptured = false;
        };
        _this.innerFocus = function () {
            _this.focusCaptured = true;
        };
        return _this;
    }
    Foco.prototype.componentDidMount = function () {
        this.init();
    };
    Foco.prototype.componentWillUnmount = function () {
        this.flush();
    };
    Foco.prototype.render = function () {
        var render = this.props.render || this.props.children;
        if (typeof render === 'function') {
            return render(this.getProps());
        }
        return this.renderComponent();
    };
    Foco.prototype.renderComponent = function () {
        return react_1.default.createElement(this.props.component || 'span', this.getProps(), this.props.children);
    };
    Foco.prototype.getProps = function () {
        return {
            className: this.props.className,
            style: this.props.style,
            onMouseDown: this.innerClick,
            onFocus: this.innerFocus,
            onTouchStart: this.innerClick
        };
    };
    Foco.prototype.init = function () {
        document.addEventListener('mousedown', this.documentClick);
        document.addEventListener('focus', this.documentFocus, true);
        document.addEventListener('touchstart', this.documentClick);
    };
    Foco.prototype.flush = function () {
        document.removeEventListener('mousedown', this.documentClick);
        document.removeEventListener('focus', this.documentFocus, true);
        document.removeEventListener('touchstart', this.documentClick);
    };
    return Foco;
}(react_1.default.Component));
exports.default = Foco;
